<template>
  <div class="sc-cart-container">
    <div v-if="showNotification">
      <div class="sc-cart-notification">
        <slot name="notification"></slot>
      </div>
      <div class="sc-cart-notification-arrow"></div>
    </div>
    <i
      class="sc-cart-icon sc-icon-cart-empty sc-cart-empty-cart sc-cart-badge"
      :class="{ 'sc-cart-filled-cart': !isEmpty, 'sc-icon-cart-filled': !isEmpty }"
      :data-quantity="sumQuantity">
    </i>
    <div class="sc-cart-center-align">
      <slot :total="total" name="cart"></slot>
    </div>
  </div>
</template>

<script>
import EventBus from '../../utils/EventBus'
import CartEvent from '../utils/CartEvent'
import CartService from '../services/CartService'

export default {
  name: 'ScCart',
  props: {
    notification: {
      type: Boolean,
      default: true
    },
    notificationDelay: {
      type: Number,
      default: 4000
    }
  },

  data () {
    return {
      isEmpty: true,
      total: null,
      sumQuantity: null,
      showNotification: false,
      notificationTimeout: null
    }
  },
  mounted () {
    this.handleCartEvents()
    this.onAddToCart()
  },
  methods: {
    onAddToCart () {
      EventBus.$on(CartEvent.ADD_PRODUCT, state => {
        if (!this.sumQuantity || this.sumQuantity < state.sumQuantity) {
          if (this.notification) {
            this.displayNotification()
          }
          this.setTotalAndQuantity(state)
        }
      })
    },
    handleCartEvents () {
      EventBus.$on([CartEvent.REMOVE_PRODUCT, CartEvent.CLEAR, CartEvent.UPDATE_PRODUCT], state => {
        this.setTotalAndQuantity(state)
      })

      CartService.afterInit((state) => {
        this.setTotalAndQuantity(state)
      })
    },
    setTotalAndQuantity (state) {
      if (state.sumQuantity) {
        this.isEmpty = false
        this.total = state.total
        this.sumQuantity = state.sumQuantity
      } else {
        this.isEmpty = true
        this.sumQuantity = null
        this.total = null
      }
    },
    displayNotification () {
      clearTimeout(this.notificationTimeout)
      this.showNotification = true
      this.notificationTimeout = setTimeout(() => {
        this.showNotification = false
      }, this.notificationDelay)
    }
  }
}
</script>

<style lang="scss" scoped>
.sc-cart-container {
  display: inline-flex;
  position: relative;
}
.sc-cart-notification {
  position: absolute;
  padding: $sc-cart-notification-padding;
  border-radius: 2px;
  background-color: $sc-cart-notification-bg;
  top: $sc-cart-notification-top;
  right: $sc-cart-notification-right;
  color: $sc-text-light;
  font-size: $sc-cart-notification-font-size;
  width: $sc-cart-notification-width;
  z-index: 2;
}
.sc-cart-notification-arrow {
  position: absolute;
  width: $sc-cart-notification-arrow-size;
  height: $sc-cart-notification-arrow-size;
  top: $sc-cart-notification-arrow-top;
  right: $sc-cart-notification-arrow-right;
  transform: rotate(45deg);
  background-color: $sc-cart-notification-bg;
  z-index: 1;
}
.sc-cart-center-align {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sc-cart-icon {
  font-size: $sc-cart-icon-font-size;
}
.sc-cart-empty-cart {
  color: $sc-cart-empty-cart-color;
}
.sc-cart-filled-cart {
  color: $sc-cart-filled-cart-color;
}
.sc-cart-badge {
  position: relative;
}
.sc-cart-badge[data-quantity]:after {
  position: absolute;
  background: $sc-cart-badge-bg;
  color: $sc-text-light;
  right: $sc-cart-badge-right;
  top: $sc-cart-badge-top;
  content: attr(data-quantity);
  border-radius: 50%;
  font-weight: $sc-cart-badge-font-weight;
  font-size: $sc-cart-badge-font-size;
  padding: $sc-cart-badge-padding;
  min-width: $sc-cart-badge-min-size;
  min-height: $sc-cart-badge-min-size;
  line-height: $sc-cart-badge-line-height;
  font-style: $sc-cart-badge-font-style;
}
</style>
